import * as React from 'react';
import type { SVGProps } from 'react';

const IconStar = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" {...props}>
    <path
      d="M22.68 8.98a.41.41 0 0 0-.4-.28h-7.77l-2.4-7.47c-.1-.33-.66-.33-.77 0L8.94 8.7H1.16a.41.41 0 0 0-.39.28c-.04.16.01.35.15.46l6.3 4.61-2.4 7.48c-.14.35.33.68.62.44l6.29-4.61 6.29 4.61c.3.24.75-.09.62-.44l-2.4-7.48 6.3-4.61c.13-.1.19-.3.14-.46Z"
      fill="currentColor"
    />
  </svg>
);
export default IconStar;
